/**
 * The layout of elements perpendicular to the stack orientation.
 */
export var StackAlignment = {
  Baseline: 'baseline',
  Center: 'center',
  Fill: 'fill',
  Leading: 'leading',
  Trailing: 'trailing'
};